<script>
import {
  noticeContent, noticeContent_sendMessageWithAttachment
} from "@/lib/request";
import {blurRule} from '@/untils/common';
import pdf from 'vue-pdf';
import { saveAs } from 'file-saver';
export default {
  name:'viewPdf',
  data() {
    return {
      tipsFlag: false,
      showPopup: false,
      infoObj: {},
      pdfUrl: '',
      recipient: '',
      numPages: []
    };
  },
  components: {pdf},
  watch: {},
  computed: {},
  methods: {
    getSubmit() {
      if (!this.recipient) {
        this.$toast('请输入您的邮箱');
        return false;
      } else if (!blurRule(this.recipient, {name: 'email'})) {
        return false;
      }
      noticeContent_sendMessageWithAttachment({
        recipient: this.recipient,
        title: this.infoObj.title,
        test: this.infoObj.remark,
        url: this.infoObj.accessoryurl,
      }).then((res) => {
        if (res) {
          if (res.data.code === 200) {
            this.tipsFlag = false;
            this.$toast.success('已发送成功，请注意查收!');
          } else {
            this.$toast(res.data.msg);
            return false;
          }
        }
      });
    },
    getListData(id) {
      noticeContent({id: id}).then((res) => {
        if (res) {
          if (res.data.code === 200) {
            this.infoObj = res.data.data;
          } else {
            this.$toast(res.data.msg);
            return false;
          }
        }
      });
    },
    // 222222
    async handleDownload() {
      try {
        const response = await fetch(this.infoObj.accessoryurl);
        const blob = await response.blob();
        if (this.getIsIOS()) {
          console.log('111111111')
          const reader = new FileReader();
          reader.onload = () => {
            const link = document.createElement('a');
            link.href = reader.result;
            link.download = this.infoObj.title;
            document.body.appendChild(link);
            console.log('11111document1111')
            link.click();
            document.body.removeChild(link);
          };
          reader.readAsDataURL(blob);
        } else {
          console.log('000000000')
          saveAs(blob, this.infoObj.title);
        }
      } catch (error) {
        alert('下载失败，请检查网络或文件URL');
      }
    },
    getIsIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    // 111111
    getDown() {
      this.tipsFlag = true;
      // console.log('下载')
      // const pdfUrl = this.infoObj.accessoryurl;//'https://example.com/sample.pdf'; // 替换为实际PDF地址
      // const fileName = this.infoObj.title + '.pdf';
      //
      // if (this.isIOS()) {
      //   this.handleIOSDownload(pdfUrl, fileName);
      // } else {
      //   this.handleAndroidDownload(pdfUrl, fileName);
      // }
    },
    isIOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent);
    },
    handleIOSDownload(url, fileName) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    },
    handleAndroidDownload(url, fileName) {
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async getDpf() {
      if (!this.infoObj.accessoryurl) {
        this.$toast('暂无PDF文件');
        return;
      }

      this.showPopup = true;

      try {
        // 确保URL是完整的
        let pdfUrl = this.infoObj.accessoryurl;
        // console.log(pdfUrl)
        // if (!pdfUrl.startsWith('http')) {
        //   // 如果是相对路径，添加基础URL
        //   pdfUrl = process.env.VUE_APP_BASE_API + pdfUrl;
        // }
        // console.log(pdfUrl)
        // 创建PDF加载任务
        const loadingTask = pdf.createLoadingTask(pdfUrl);

        // 监听加载过程
        loadingTask.onProgress = (progress) => {
          console.log('PDF加载进度:', progress);
        };

        const pdfDocument = await loadingTask.promise;
        this.numPages = pdfDocument.numPages;

        console.log('PDF加载成功，总页数:', this.numPages);

      } catch (error) {
        console.error('PDF加载失败:', error);
        // this.pdfError = true;
        // this.errorMessage = this.getErrorMessage(error);
        this.$toast('PDF加载失败');
      } finally {
        console.log('finally:');
        // this.pdfLoading = false;
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.getListData(this.$route.query.id);
    } else {
      this.$toast('暂无通知id！');
      return false;
    }
  }
}
</script>
<template>
  <div class="sun-warp">
    <van-popup
        v-model="showPopup"
        round
        position="center"
        style="width: 100%;height: 90%;overflow-x: hidden"
        closeable
        close-icon-position="top-right"
        :close-on-click-overlay="false"
        @close="showPopup=false"
    >
      <pdf
          :src="infoObj.accessoryurl"
          v-for="page in numPages"
          :key="page"
          :page="page"
      ></pdf>
    </van-popup>

    <!--  模态弹窗-->
    <van-popup v-model="tipsFlag" round position="center" :close-on-click-overlay="false" :style="{width:'90%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="tipsFlag=false">&times;</div>
          <div class="section-title">
            发送至邮箱
          </div>
        </div>
        <div class="tabs-group">
          <div class="form-group-item">
            <div class="form-group-label">邮箱 <span>*</span></div>
            <div class="form-group-text">
              <van-field type="text" v-model="recipient" placeholder="请输入您的邮箱"
                         :rules="[{ required: true, message: `请输入您的邮箱` }]"></van-field>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <span class="erase" @click="tipsFlag=false">取消</span>
          <span class="leg" @click="getSubmit()">确认发送</span>
        </div>
      </div>
    </van-popup>
    <div v-if="infoObj.title">
      <div class="sun-header">
        <div class="sun-title">{{ infoObj.title }}</div>
      </div>
      <div class="ql-editor" v-html="infoObj.article"></div>
      <div style="display: flex;flex-flow: row;gap:20px;padding: 0 20px;">
        <van-button class="sub-btn" block type="primary" v-if="infoObj.accessoryurl" color="#e62d2d" @click="getDpf">
          点击查看附件
        </van-button>
        <!--       -->
        <van-button class="sub-em" block type="primary" v-if="infoObj.accessoryurl" @click="getDown">
          发送至邮箱
        </van-button>
      </div>
    </div>
    <div v-else>消息内容数据为空！</div>
  </div>
</template>
<style scoped lang="scss">
.sun-warp {
  position: relative;
  left: 0;
  top: 0;
  font-size: 28px;
  height: 100vh;
  overflow: hidden;
  padding: 20px;

  .sub-btn {
    border-radius: 7px;
    height: 70px;
  }

  .sub-em {
    border-radius: 7px;
    height: 70px;
    background: #fff;
    border: 1px solid #e62d2d;
    color: #e62d2d;
  }

  .sun-header {
    display: flex;
    flex-direction: column;

    .sun-title {
      display: flex;
      justify-content: center;
      font-size: 38px;
      font-weight: bold;
      padding: 10px 0 0;
    }

    .sun-text {
      display: flex;
      justify-content: center;
      font-size: 26px;
    }
  }

  .html-text {
    padding: 0 20px;
    font-size: 30px;

    p {
      font-size: 30px !important;
    }

    div {
      font-size: 30px !important;;
    }

  }

  /deep/ .ql-container {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    height: 100%;
    margin: 0;
    position: relative;
  }

  /deep/ .ql-container.ql-disabled .ql-tooltip {
    visibility: hidden;
  }

  /deep/ .ql-container.ql-disabled .ql-editorul[data-checked] > li::before {
    pointer-events: none;
  }

  /deep/ .ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }

  /deep/ .ql-clipboard p {
    margin: 0;
    padding: 0;
  }

  /deep/ .ql-editor {
    box-sizing: border-box;
    line-height: 1.42;
    height: auto;
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;

    p {
      display: inline-block;

      img {
        width: 100%;
      }
    }
  }

  /deep/ .ql-editor > * {
    cursor: text;
    width: 100%;
  }

  /deep/ .ql-editorp,
  .ql-editorol,
  .ql-editorul,
  .ql-editorpre,
  .ql-editorblockquote,
  .ql-editorh1,
  .ql-editorh2,
  .ql-editorh3,
  .ql-editorh4,
  .ql-editorh5,
  .ql-editorh6 {
    margin: 0;
    padding: 0;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }

  /deep/ .ql-editorol,
  .ql-editorul {
    padding-left: 1.5em;
  }

  /deep/ .ql-editorol > li,
  .ql-editorul > li {
    list-style-type: none;
  }

  /deep/ .ql-editorul > li::before {
    content: '\2022';
  }

  /deep/ .ql-editorul[data-checked=true],
  .ql-editorul[data-checked=false] {
    pointer-events: none;
  }

  /deep/ .ql-editorul[data-checked=true] > li *,
  .ql-editorul[data-checked=false] > li * {
    pointer-events: all;
  }

  /deep/ .ql-editorul[data-checked=true] > li::before,
  .ql-editorul[data-checked=false] > li::before {
    color: #777;
    cursor: pointer;
    pointer-events: all;
  }

  /deep/ .ql-editorul[data-checked=true] > li::before {
    content: '\2611';
  }

  /deep/ .ql-editorul[data-checked=false] > li::before {
    content: '\2610';
  }

  /deep/ .ql-editorli::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }

  /deep/ .ql-editorli:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
  }

  /deep/ .ql-editorli.ql-direction-rtl::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
  }

  /deep/ .ql-editorol li:not(.ql-direction-rtl),
  .ql-editorul li:not(.ql-direction-rtl) {
    padding-left: 1.5em;
  }

  /deep/ .ql-editorol li.ql-direction-rtl,
  .ql-editorul li.ql-direction-rtl {
    padding-right: 1.5em;
  }

  /deep/ .ql-editorol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-0;
  }

  /deep/ .ql-editorol li:before {
    content: counter(list-0, decimal) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-1 {
    counter-increment: list-1;
  }

  /deep/ .ql-editorol li.ql-indent-1:before {
    content: counter(list-1, lower-alpha) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-2 {
    counter-increment: list-2;
  }

  /deep/ .ql-editorol li.ql-indent-2:before {
    content: counter(list-2, lower-roman) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-3 {
    counter-increment: list-3;
  }

  /deep/ .ql-editorol li.ql-indent-3:before {
    content: counter(list-3, decimal) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-4 {
    counter-increment: list-4;
  }

  /deep/ .ql-editorol li.ql-indent-4:before {
    content: counter(list-4, lower-alpha) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-5 {
    counter-increment: list-5;
  }

  /deep/ .ql-editorol li.ql-indent-5:before {
    content: counter(list-5, lower-roman) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-6 {
    counter-increment: list-6;
  }

  /deep/ .ql-editorol li.ql-indent-6:before {
    content: counter(list-6, decimal) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-7 {
    counter-increment: list-7;
  }

  /deep/ .ql-editorol li.ql-indent-7:before {
    content: counter(list-7, lower-alpha) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-7 {
    counter-reset: list-8 list-9;
  }

  /deep/ .ql-editorol li.ql-indent-8 {
    counter-increment: list-8;
  }

  /deep/ .ql-editorol li.ql-indent-8:before {
    content: counter(list-8, lower-roman) '. ';
  }

  /deep/ .ql-editorol li.ql-indent-8 {
    counter-reset: list-9;
  }

  /deep/ .ql-editorol li.ql-indent-9 {
    counter-increment: list-9;
  }

  /deep/ .ql-editorol li.ql-indent-9:before {
    content: counter(list-9, decimal) '. ';
  }

  /deep/ .ql-editor.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }

  /deep/ .ql-editorli.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 4.5em;
  }

  /deep/ .ql-editor.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3em;
  }

  /deep/ .ql-editorli.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 4.5em;
  }

  /deep/ .ql-editor.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em;
  }

  /deep/ .ql-editorli.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 7.5em;
  }

  /deep/ .ql-editor.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 6em;
  }

  /deep/ .ql-editorli.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 7.5em;
  }

  /deep/ .ql-editor.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em;
  }

  /deep/ .ql-editorli.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 10.5em;
  }

  /deep/ .ql-editor.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 9em;
  }

  /deep/ .ql-editorli.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 10.5em;
  }

  /deep/ .ql-editor.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 12em;
  }

  /deep/ .ql-editorli.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 13.5em;
  }

  /deep/ .ql-editor.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 12em;
  }

  /deep/ .ql-editorli.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 13.5em;
  }

  /deep/ .ql-editor.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 15em;
  }

  /deep/ .ql-editorli.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 16.5em;
  }

  /deep/ .ql-editor.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 15em;
  }

  /deep/ .ql-editorli.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 16.5em;
  }

  /deep/ .ql-editor.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 18em;
  }

  /deep/ .ql-editorli.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 19.5em;
  }

  /deep/ .ql-editor.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 18em;
  }

  /deep/ .ql-editorli.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 19.5em;
  }

  /deep/ .ql-editor.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 21em;
  }

  /deep/ .ql-editorli.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 22.5em;
  }

  /deep/ .ql-editor.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 21em;
  }

  /deep/ .ql-editorli.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 22.5em;
  }

  /deep/ .ql-editor.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 24em;
  }

  /deep/ .ql-editorli.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 25.5em;
  }

  /deep/ .ql-editor.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 24em;
  }

  /deep/ .ql-editorli.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 25.5em;
  }

  /deep/ .ql-editor.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 27em;
  }

  /deep/ .ql-editorli.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 28.5em;
  }

  /deep/ .ql-editor.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 27em;
  }

  /deep/ .ql-editorli.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 28.5em;
  }

  /deep/ .ql-editor.ql-video {
    display: block;
    max-width: 100%;
  }

  /deep/ .ql-editor.ql-video.ql-align-center {
    margin: 0 auto;
  }

  /deep/ .ql-editor.ql-video.ql-align-right {
    margin: 0 0 0 auto;
  }

  /deep/ .ql-editor.ql-bg-black {
    background-color: #000;
  }

  /deep/ .ql-editor.ql-bg-red {
    background-color: #e60000;
  }

  /deep/ .ql-editor.ql-bg-orange {
    background-color: #f90;
  }

  /deep/ .ql-editor.ql-bg-yellow {
    background-color: #ff0;
  }

  /deep/ .ql-editor.ql-bg-green {
    background-color: #008a00;
  }

  /deep/ .ql-editor.ql-bg-blue {
    background-color: #06c;
  }

  /deep/ .ql-editor.ql-bg-purple {
    background-color: #93f;
  }

  /deep/ .ql-editor.ql-color-white {
    color: #fff;
  }

  /deep/ .ql-editor.ql-color-red {
    color: #e60000;
  }

  /deep/ .ql-editor.ql-color-orange {
    color: #f90;
  }

  /deep/ .ql-editor.ql-color-yellow {
    color: #ff0;
  }

  /deep/ .ql-editor.ql-color-green {
    color: #008a00;
  }

  /deep/ .ql-editor.ql-color-blue {
    color: #06c;
  }

  /deep/ .ql-editor.ql-color-purple {
    color: #93f;
  }

  /deep/ .ql-editor.ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
  }

  /deep/ .ql-editor.ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
  }

  /deep/ .ql-editor.ql-size-small {
    font-size: 0.75em;
  }

  /deep/ .ql-editor.ql-size-large {
    font-size: 1.5em;
  }

  /deep/ .ql-editor.ql-size-huge {
    font-size: 2.5em;
  }

  /deep/ .ql-editor.ql-direction-rtl {
    direction: rtl;
    text-align: inherit;
  }

  /deep/ .ql-editor .ql-align-center {
    text-align: center;
  }

  /deep/ .ql-editor .ql-align-justify {
    text-align: justify;
  }

  /deep/ .ql-editor .ql-align-right {
    text-align: right;
  }

  /deep/ .ql-editor.ql-blank::before {
    color: rgba(0, 0, 0, 0.6);
    content: attr(data-placeholder);
    font-style: italic;
    left: 15px;
    pointer-events: none;
    position: absolute;
    right: 15px;
  }

  /deep/ .ql-snow.ql-toolbar:after,
  .ql-snow .ql-toolbar:after {
    clear: both;
    content: '';
    display: table;
  }

  /deep/ .ql-snow.ql-toolbar button,
  .ql-snow .ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    display: inline-block;
    float: left;
    height: 24px;
    padding: 3px 5px;
    width: 28px;
    margin-left: 1px;
    margin-right: 1px;
  }

  /deep/ .ql-snow.ql-toolbar button svg,
  .ql-snow .ql-toolbar button svg {
    float: left;
    height: 100%;
  }

  /deep/ .ql-snow.ql-toolbar button:active:hover,
  .ql-snow .ql-toolbar button:active:hover {
    outline: none;
  }

  /deep/ .ql-snow.ql-toolbar input.ql-image[type=file],
  .ql-snow .ql-toolbar input.ql-image[type=file] {
    display: none;
  }

  /deep/ .ql-snow.ql-toolbar button:hover,
  .ql-snow .ql-toolbar button:hover,
  .ql-snow.ql-toolbar button:focus,
  .ql-snow .ql-toolbar button:focus,
  .ql-snow.ql-toolbar .ql-picker-label:hover,
  .ql-snow .ql-toolbar .ql-picker-label:hover,
  .ql-snow.ql-toolbar .ql-picker-item:hover,
  .ql-snow .ql-toolbar .ql-picker-item:hover {
    background-color: #f3f4f6;
  }

  /deep/ .ql-snow.ql-toolbar button.ql-active,
  .ql-snow .ql-toolbar button.ql-active,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
    background-color: #dbeafe;
    color: #2563eb;
  }

  /deep/ .ql-snow.ql-toolbar button.ql-active .ql-fill,
  .ql-snow .ql-toolbar button.ql-active .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
    fill: #2563eb;
  }

  /deep/ .ql-snow.ql-toolbar button.ql-active .ql-stroke,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
    stroke: #2563eb;
  }

  @media (pointer: coarse) {
    /deep/ .ql-snow.ql-toolbar button:hover:not(.ql-active),
    .ql-snow .ql-toolbar button:hover:not(.ql-active) {
      color: #4b5563;
    }
    /deep/ .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
      fill: #4b5563;
    }
    /deep/ .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
      stroke: #4b5563;
    }
  }

  /deep/ .ql-snow {
    box-sizing: border-box;
  }

  /deep/ .ql-snow * {
    box-sizing: border-box;
  }

  /deep/ .ql-snow .ql-hidden {
    display: none;
  }

  /deep/ .ql-snow .ql-out-bottom,
  .ql-snow .ql-out-top {
    visibility: hidden;
  }

  /deep/ .ql-snow .ql-tooltip {
    position: absolute;
    transform: translateY(10px);
  }

  /deep/ .ql-snow .ql-tooltip a {
    cursor: pointer;
    text-decoration: none;
  }

  /deep/ .ql-snow .ql-tooltip.ql-flip {
    transform: translateY(-10px);
  }

  /deep/ .ql-snow .ql-formats {
    display: inline-block;
    vertical-align: middle;
  }

  /deep/ .ql-snow .ql-formats:after {
    clear: both;
    content: '';
    display: table;
  }

  /deep/ .ql-snow .ql-stroke {
    fill: none;
    stroke: #4b5563;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }

  /deep/ .ql-snow .ql-stroke-miter {
    fill: none;
    stroke: #4b5563;
    stroke-miterlimit: 10;
    stroke-width: 2;
  }

  /deep/ .ql-snow .ql-fill,
  .ql-snow .ql-stroke.ql-fill {
    fill: #4b5563;
  }

  /deep/ .ql-snow .ql-empty {
    fill: none;
  }

  /deep/ .ql-snow .ql-even {
    fill-rule: evenodd;
  }

  /deep/ .ql-snow .ql-thin,
  .ql-snow .ql-stroke.ql-thin {
    stroke-width: 1;
  }

  /deep/ .ql-snow .ql-transparent {
    opacity: 0.4;
  }

  /deep/ .ql-snow .ql-direction svg:last-child {
    display: none;
  }

  /deep/ .ql-snow .ql-direction.ql-active svg:last-child {
    display: inline;
  }

  /deep/ .ql-snow .ql-direction.ql-active svg:first-child {
    display: none;
  }

  /deep/ .ql-snow .ql-editorh1 {
    font-size: 2em;
  }

  /deep/ .ql-snow .ql-editorh2 {
    font-size: 1.5em;
  }

  /deep/ .ql-snow .ql-editorh3 {
    font-size: 1.17em;
  }

  /deep/ .ql-snow .ql-editorh4 {
    font-size: 1em;
  }

  /deep/ .ql-snow .ql-editorh5 {
    font-size: 0.83em;
  }

  /deep/ .ql-snow .ql-editorh6 {
    font-size: 0.67em;
  }

  /deep/ .ql-snow .ql-editora {
    text-decoration: underline;
  }

  /deep/ .ql-snow .ql-editorblockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }

  /deep/ .ql-snow .ql-editorcode,
  .ql-snow .ql-editorpre {
    background-color: #f0f0f0;
    border-radius: 3px;
  }

  /deep/ .ql-snow .ql-editorpre {
    white-space: pre-wrap;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px;
  }

  /deep/ .ql-snow .ql-editorcode {
    font-size: 85%;
    padding: 2px 4px;
  }

  /deep/ .ql-snow .ql-editorpre.ql-syntax {
    background-color: #23241f;
    color: #f8f8f2;
    overflow: visible;
  }

  /deep/ .ql-snow .ql-editorimg {
    max-width: 100%;
  }

  /deep/ .ql-snow .ql-picker {
    color: #4b5563;
    display: inline-block;
    float: left;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    position: relative;
    vertical-align: middle;
    margin-right: 1px;
    margin-left: 1px;
  }

  /deep/ .ql-snow .ql-picker-label {
    cursor: pointer;
    display: flex;
    height: 100%;
    padding-left: 8px;
    padding-right: 2px;
    position: relative;
    width: 100%;
  }

  /deep/ .ql-snow .ql-picker-label::before {
    display: inline-block;
    line-height: 22px;
  }

  /deep/ .ql-snow .ql-picker-options {
    background-color: #fff;
    display: none;
    min-width: 100%;
    position: absolute;
    white-space: nowrap;
  }

  /deep/ .ql-snow .ql-picker-options .ql-picker-item {
    cursor: pointer;
    display: block;
    padding: 5px 8px;
  }

  /deep/ .ql-snow .ql-picker.ql-expanded .ql-picker-label {
    color: #d1d5db;
    z-index: 2;
  }

  /deep/ .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #d1d5db;
  }

  /deep/ .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #d1d5db;
  }

  /deep/ .ql-snow .ql-picker.ql-expanded .ql-picker-options {
    display: block;
    margin-top: -1px;
    top: 100%;
    z-index: 1;
  }

  /deep/ .ql-snow .ql-color-picker,
  .ql-snow .ql-icon-picker {
    width: 28px;
  }

  /deep/ .ql-snow .ql-color-picker .ql-picker-label,
  .ql-snow .ql-icon-picker .ql-picker-label {
    padding: 2px 4px;
  }

  /deep/ .ql-snow .ql-color-picker .ql-picker-label svg,
  .ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px;
  }

  /deep/ .ql-snow .ql-icon-picker .ql-picker-options {
    padding: 3px;
  }

  /deep/ .ql-snow .ql-icon-picker .ql-picker-item {
    height: 24px;
    width: 24px;
    padding: 2px 4px;
    margin: 2px;
  }

  /deep/ .ql-snow .ql-color-picker .ql-picker-options {
    padding: 3px 5px;
    width: 152px;
  }

  /deep/ .ql-snow .ql-color-picker .ql-picker-item {
    border: 1px solid transparent;
    float: left;
    height: 16px;
    margin: 2px;
    padding: 0;
    width: 16px;
  }

  /deep/ .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    position: absolute;
    margin-top: -9px;
    right: 0;
    top: 50%;
    width: 18px;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }

  /deep/ .ql-snow .ql-picker.ql-header {
    width: 98px;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: 'Normal';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: 'Heading 1';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: 'Heading 2';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: 'Heading 3';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: 'Heading 4';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: 'Heading 5';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: 'Heading 6';
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    font-size: 2em;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    font-size: 1.5em;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    font-size: 1.17em;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    font-size: 1em;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    font-size: 0.83em;
  }

  /deep/ .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    font-size: 0.67em;
  }

  /deep/ .ql-snow .ql-picker.ql-font {
    width: 108px;
  }

  /deep/ .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: 'Sans Serif';
  }

  /deep/ .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: 'Serif';
  }

  /deep/ .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: 'Monospace';
  }

  /deep/ .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    font-family: Georgia, Times New Roman, serif;
  }

  /deep/ .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    font-family: Monaco, Courier New, monospace;
  }

  /deep/ .ql-snow .ql-picker.ql-size {
    width: 98px;
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: 'Normal';
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: 'Small';
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: 'Large';
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: 'Huge';
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    font-size: 10px;
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    font-size: 18px;
  }

  /deep/ .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    font-size: 32px;
  }

  /deep/ .ql-snow .ql-color-picker.ql-background .ql-picker-item {
    background-color: #fff;
  }

  /deep/ .ql-snow .ql-color-picker.ql-color .ql-picker-item {
    background-color: #000;
  }

  /deep/ .ql-toolbar.ql-snow {
    border: 1px solid #d1d5db;
    box-sizing: border-box;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    padding: 8px;
  }

  /deep/ .ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
  }

  /deep/ .ql-toolbar.ql-snow .ql-picker-label {
    border: 1px solid transparent;
  }

  /deep/ .ql-toolbar.ql-snow .ql-picker-options {
    border: 1px solid transparent;
    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
  }

  /deep/ .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    border-color: #d1d5db;
  }

  /deep/ .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #d1d5db;
  }

  /deep/ .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
    border-color: #000;
  }

  /deep/ .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0;
  }

  /deep/ .ql-snow .ql-tooltip {
    background-color: #fff;
    border: 1px solid #d1d5db;
    box-shadow: 0 0 5px #d1d5db;
    color: #4b5563;
    padding: 5px 12px;
    white-space: nowrap;
  }

  /deep/ .ql-snow .ql-tooltip::before {
    content: "Visit URL:";
    line-height: 26px;
    margin-right: 8px;
  }

  /deep/ .ql-snow .ql-tooltip input[type=text] {
    display: none;
    border: 1px solid #d1d5db;
    font-size: 13px;
    height: 26px;
    margin: 0;
    padding: 3px 5px;
    width: 170px;
  }

  /deep/ .ql-snow .ql-tooltip a.ql-preview {
    display: inline-block;
    max-width: 200px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }

  /deep/ .ql-snow .ql-tooltip a.ql-action::after {
    border-right: 1px solid #d1d5db;
    content: 'Edit';
    margin-left: 16px;
    padding-right: 8px;
  }

  /deep/ .ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Remove';
    margin-left: 8px;
  }

  /deep/ .ql-snow .ql-tooltip a {
    line-height: 26px;
  }

  /deep/ .ql-snow .ql-tooltip.ql-editing a.ql-preview,
  /deep/ .ql-snow .ql-tooltip.ql-editing a.ql-remove {
    display: none;
  }

  /deep/ .ql-snow .ql-tooltip.ql-editing input[type=text] {
    display: inline-block;
  }

  /deep/ .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0;
    content: 'Save';
    padding-right: 0;
  }

  /deep/ .ql-snow .ql-tooltip[data-mode=link]::before {
    content: "Enter link:";
  }

  /deep/ .ql-snow .ql-tooltip[data-mode=formula]::before {
    content: "Enter formula:";
  }

  /deep/ .ql-snow .ql-tooltip[data-mode=video]::before {
    content: "Enter video:";
  }

  /deep/ .ql-snow a {
    color: #2563eb;
  }

  /deep/ .ql-container.ql-snow {
    border: 1px solid #d1d5db;
  }

}

.inner-diag {
  //display: flex;
  //flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 30px;

  .title-had {
    //position: fixed;
    //left: 0;
    //top: 0;
    //z-index: 19;
    //height: 100px;
    //width: 100%;
    padding: 40px 30px 10px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;

    .fixed-close {
      position: absolute;
      right: 50px;
      top: 19px;
      font-size: 50px;
      color: #999;
    }

    .section-title {
      font-size: 32px;
      background: #fff;
    }
  }

  .form-buttons {
    width: 100%;
    display: inline-block;
    border-top: 1px solid #e5e7eb;
    text-align: right;
    padding-top: 20px;

    span {
      display: inline-block;
      border: 1px solid #e5e7eb;;
      padding: 15px 35px;
      border-radius: 10px;
      margin-right: 20px;
    }

    .erase {
      background: #f3f4f6;
      color: #666;
    }

    .leg {
      background: #e62d2d; //linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }
  }

  .tabs-group {
    padding: 30px 30px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;

    .form-group-item {
      display: flex;
      flex-flow: column;

      .form-group-label {
        padding: 0 0 10px;
        font-weight: bold;
        color: #666;

        span {
          color: red;
          display: inline-block;
        }
      }

      .form-group-text {
        background: #f9f9f9;

        /deep/ .van-cell {
          background: #f9f9f9;

        }
      }
    }

    .con-app {
      color: red;
    }

    .pub {
      background: #f9fafb;
      padding: 30px 15px;
      border-radius: 12px;
      margin-bottom: 20px;
    }
  }
}
</style>